"use client"

import { useState, useEffect } from "react"
import { motion } from "framer-motion"
import { Shield, Activity, Users, Globe } from "lucide-react"

export function ServerStatus() {
    const [stats, setStats] = useState({
        online: 0,
        status: "Stable",
        uptime: "99.9%",
        accounts: 0
    })

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const res = await fetch("/api/stats")
                if (res.ok) {
                    const data = await res.json()
                    setStats({
                        online: data.totalOnline || 0,
                        status: "Stable",
                        uptime: "99.9%",
                        accounts: data.totalAccounts || 0
                    })
                }
            } catch (error) {
                console.error("Failed to fetch server stats")
            }
        }
        fetchStats()
    }, [])

    return (
        <section className="relative py-12 -mt-16 z-20 container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-slate-800/50 backdrop-blur-xl border border-slate-700/50 rounded-2xl overflow-hidden shadow-2xl">
                {/* Server Status */}

                {/* Server Status */}
                <div className="bg-slate-900/40 p-6 flex flex-col items-center justify-center group hover:bg-slate-800/60 transition-colors">
                    <div className="flex items-center gap-3 text-emerald-400 mb-2">
                        <Activity className="w-5 h-5" />
                        <span className="text-xs font-bold uppercase tracking-widest">Network Status</span>
                    </div>
                    <div className="flex items-center gap-2 text-4xl font-black text-white tracking-tighter">
                        ONLINE
                        <span className="relative flex h-3 w-3">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-emerald-500"></span>
                        </span>
                    </div>
                    <div className="text-xs font-medium text-emerald-400/60 mt-2 uppercase tracking-tight italic">
                        All Systems Operational
                    </div>
                </div>

                {/* Uptime */}
                <div className="bg-slate-900/40 p-6 flex flex-col items-center justify-center group hover:bg-slate-800/60 transition-colors">
                    <div className="flex items-center gap-3 text-amber-400 mb-2">
                        <Shield className="w-5 h-5" />
                        <span className="text-xs font-bold uppercase tracking-widest">System Guard</span>
                    </div>
                    <div className="text-4xl font-black text-white tracking-tighter">
                        {stats.uptime}
                    </div>
                    <div className="text-xs font-medium text-amber-400/60 mt-2 uppercase tracking-tight italic">
                        DDoS Protected
                    </div>
                </div>

                {/* Market/Global Stats */}
                <div className="bg-slate-900/40 p-6 flex flex-col items-center justify-center group hover:bg-slate-800/60 transition-colors">
                    <div className="flex items-center gap-3 text-purple-400 mb-2">
                        <Globe className="w-5 h-5" />
                        <span className="text-xs font-bold uppercase tracking-widest">Total Population</span>
                    </div>
                    <div className="text-4xl font-black text-white tabular-nums tracking-tighter">
                        {stats.accounts}
                    </div>
                    <div className="text-xs font-medium text-purple-400/60 mt-2 uppercase tracking-tight italic">
                        New Heroes daily
                    </div>
                </div>
            </div>
        </section>
    )
}
